import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-mapa-reto-verde',
  templateUrl: './mapa-reto-verde.component.html',
  styleUrls: ['./mapa-reto-verde.component.scss']
})
export class MapaRetoVerdeComponent implements OnInit, AfterViewInit {
  map: any;
  layerGroup: any;
  layerGroupShapes: any;

  @Input() sedes: any;

  @ViewChild('primaryMap', {static: true}) protected mapDivRef: ElementRef;
  protected mapDiv: HTMLDivElement;

  constructor() { }

  ngOnInit(): void {
    this.mapDiv = this.mapDivRef.nativeElement;
  }

  ngAfterViewInit() {
    const myAPIKey = "0162482e691040afa6ac3cbfc6dbc92d";
    const mapStyle = "https://maps.geoapify.com/v1/styles/osm-carto/style.json";

    this.map = L.map('map', { scrollWheelZoom: false }).setView([19.369903, -99.148074], 12);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
 			maxZoom: 16,
 			minZoom: 10,
 		}).addTo(this.map);

    this.layerGroup = L.layerGroup().addTo(this.map);
    this.layerGroupShapes = L.layerGroup().addTo(this.map);

    this.buildMap(this.sedes.filters);
  }

  private buildMap (sedes) {
    let iconMarker = L.icon({
      iconUrl: 'assets/images/marker-icon.png'
    })
    sedes.map(async (arr) => {
      if (arr.geo_shape) {
        L.geoJSON(JSON.parse(arr.geo_shape), {
          style: {
            "color": "#1D4439",
            "fillColor": "#8DB85D",
            "weight": 2
          },
        }).on('mouseover', function (e) {
          e.layer.bindTooltip(`
            <div style="background: white; color: black; width: 340px; padding: 8px; border-radius: 8px; ">
              <h3><b>Alcaldía:</b> ${arr.alcaldia}</h3>
              <p class="mb-0" style="font-size: 14px !important;"><b>Categoría:</b> ${arr.categoria}</p>
              <p class="mb-0 text-wrap" style="font-size: 14px !important;"><b>Domicilio:</b><br> ${arr.domicilio}</p>
              <p class="mb-0 text-wrap" style="font-size: 14px !important;">Especies: ${arr.especies}</p>
              <p class="mb-0" style="font-size: 14px !important;"><b>Fecha inicio:</b> ${new Date(arr.fech_inic).toLocaleDateString("es-MX")}</p>
              <p class="mb-0" style="font-size: 14px !important;"><b>Fecha fin:</b> ${new Date(arr.fech_term).toLocaleDateString("es-MX")}</p>
              <p class="mb-0" style="font-size: 14px !important;"><b>Sitio:</b> ${arr.sitio}</p>
              <p class="mb-0" style="font-size: 14px !important;"><b>Programa:</b> ${arr.t_progr}</p>
              <p class="mb-0" style="font-size: 14px !important;"><b>Tipo de suelo:</b> ${arr.tipo_sue}</p>
              <p class="mb-0" style="font-size: 14px !important;"><b>Total árboles:</b> ${arr.tot_arb}</p>
            </div>
          `, { closeButton: true });
        }).addTo(this.layerGroupShapes);
      }
    });
  }
}
